export default __webpack_public_path__ + "static/media/butcher8.1b507c62.png";